if (!customElements.get('free-delivery-note')) {
  customElements.define(
    'free-delivery-note',
    class FreeDeliveryNote extends HTMLElement {
      constructor() {
        super();
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.updateFreeDeliveryNote(event.data.sectionId, event.data.html);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateFreeDeliveryNote(sectionId, html) {
        const note = html.getElementById(`Free-Delivery-Note-${sectionId}`);
        const current = this.querySelector('.product__free-delivery-note');
        const updated = note.querySelector('.product__free-delivery-note');
        if (!current || !updated) return;

        current.innerHTML = updated.innerHTML;
        current.dataset.preOrder = updated.dataset.preOrder;

        const preOrder = current.dataset.preOrder === 'true';
        if (!preOrder) return;

        const productForm = document.getElementById(`product-form-${sectionId}`);
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        addButtonText.textContent = window.variantStrings.preOrder;
      }
    }
  );
}
